import 'styles/mapLegend.scss';

// Third party components
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Shared components
import CategoryGroupLayerRenderer from 'components/CategoryGroupLayerRenderer';
import { LineLoader } from '@timmons-group/shared-react-components';

import { sortOn } from '@timmons-group/shared-react-components/helpers';
import { DATA_STATES } from '@timmons-group/shared-react-components/constants';

/*
    * This function renders a legend for a provided layer.
*/
const RenderLayer = ({ layer, idx, category, keyVal }) => {
  const [legend, updateLegend] = useState({ state: DATA_STATES.IDLE, values: [] });

  /*
      * This function is called when the legend for a layer is requested.
      * we do some tom foolery so that we dont request the legend multiple times.
  */
  useEffect(() => {
    const getLegend = async () => {
      if (legend.state !== DATA_STATES.IDLE || !category.getSelectionKeys().includes(layer.key))
        return;

      updateLegend({ state: DATA_STATES.LOADING, values: [] });
      const val = await layer.getLegend();
      updateLegend({
        state: DATA_STATES.LOADED,
        values: val?.length > 0 ? sortOn(val, 'label') : val
      });
    }
    getLegend();
  });

  if (!category.getSelectionKeys().includes(layer.key)) {
    return null;
  }

  if (legend.state !== DATA_STATES.LOADED) {
    return (
      <div className="legend-entry" key={keyVal + idx}>
        <p className="layer-name">{layer.name}</p>
        <LineLoader />
      </div>
    );
  }
  else {
    if (legend?.values?.length === 0) {  // No legend available
      return (
        <div className="legend-entry" key={keyVal}>
          <p className="layer-name">{layer.name}</p>
          <p className="layer-name">No legend available</p>
        </div>
      );
    }

    const entries = legend.values?.map((entry, index) => {
      return (
        <div className="legend-entry-value" key={index}>
          <div className="legend-entry-icon">
            {entry.icon ?
              <img src={entry.icon} alt={entry.label} />
              :
              <div className={entry.color ? 'data' : 'no-data'} style={{ backgroundColor: entry.color }}>&nbsp;</div>
            }
          </div>
          <div className="legend-entry-label">
            {entry.label || entry.value}
          </div>
        </div>
      );
    });

    return (
      <div className="legend-entry" key={keyVal}>
        <p className="layer-name">{layer.name}</p>
        {entries}
      </div>
    );
  }
}

RenderLayer.propTypes = {
  layer: PropTypes.object,
  idx: PropTypes.number,
  category: PropTypes.object,
  keyVal: PropTypes.string,
}

const MapLegend = ({ categories }) => {
  const validCategories = categories?.filter(c => {
    if (c.config?.legend?.enabled === false) {
      return false;
    }

    return true;
  });
  const legendable = validCategories?.filter(
    c => {
      const gLayers = c?.groups?.map(g => g?.layers);
      const flattened = gLayers?.reduce((a, b) => a.concat(b), []);
      return flattened.filter(
        l => {
          // return l?.getLegend && l?.config?.legend?.enabled && c.getSelectionKeys().includes(l.key)
          return l?.getLegend && c.getSelectionKeys().includes(l.key)
        }
      ).length > 0;
    }
  );

  if (legendable?.length > 0) {
    return (<CategoryGroupLayerRenderer categories={legendable} LayerRenderer={RenderLayer} renderHidden={true} />);
  } else if (legendable?.length === 0) {
    return (<div className="legend-container">
      <div className="no-selected">
        <p>No layers selected. Select a reference layer to see the legend for that layer.</p>
      </div>
    </div>);
  }

  return (<div>Loading...</div>);
}

MapLegend.propTypes = {
  categories: PropTypes.array.isRequired,
}

export default MapLegend;